import { render } from "./TablaSolicitudesPendientes.vue?vue&type=template&id=28d6ad92&scoped=true"
import script from "./TablaSolicitudesPendientes.vue?vue&type=script&lang=js"
export * from "./TablaSolicitudesPendientes.vue?vue&type=script&lang=js"

import "./TablaSolicitudesPendientes.vue?vue&type=style&index=0&id=28d6ad92&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d6ad92"]])

export default __exports__